/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Miss behaviour
 */
export enum AddQuestionnaireConfigDtoMissBehaviour {
  LATE_ALLOWED = "LATE_ALLOWED",
  HARD_MISS = "HARD_MISS",
}
